var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 15,
    viewBox: "0 0 106 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1033 7.23187C12.7102 7.18655 7.61314 10.6706 5.74496 11.0543C2.45052 11.7257 1.25294 9.06139 1.25294 9.06139C1.25294 9.06139 4.14574 8.88203 4.72395 8.03599C4.72395 8.03599 2.092 7.32713 2.00426 5.91107C2.00426 5.91107 5.82768 7.85632 8.8421 5.18652C8.8421 5.18652 7.52722 3.97785 7.62813 2.88244C7.62813 2.88244 9.08721 4.15598 10.6048 4.05843C12.1223 3.96087 15.3547 2.01675 20.5879 2.54686C31.0245 3.60408 34.5 12.5264 34.5 12.5264C34.5 12.5264 27.4974 7.26725 20.1043 7.22193L20.1033 7.23187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3151 4.94968C30.3151 4.94968 29.0212 2.83854 24.011 1.49676C20.635 0.591908 17.4446 0.83159 17.4446 0.83159C17.4446 0.83159 21.2777 -0.0968273 24.4645 0.889373C29.1711 2.35116 30.3151 4.94968 30.3151 4.94968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3313 7.23187C93.7243 7.18655 98.8214 10.6706 100.69 11.0543C103.984 11.7257 105.182 9.06139 105.182 9.06139C105.182 9.06139 102.289 8.88203 101.711 8.03599C101.711 8.03599 104.343 7.32713 104.43 5.91107C104.43 5.91107 100.607 7.85632 97.5925 5.18652C97.5925 5.18652 98.9074 3.97785 98.8064 2.88244C98.8064 2.88244 97.3474 4.15598 95.8298 4.05843C94.3122 3.96087 91.0799 2.01675 85.8466 2.54686C75.41 3.60408 71.9346 12.5264 71.9346 12.5264C71.9346 12.5264 78.9372 7.26725 86.3303 7.22193L86.3313 7.23187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1195 4.94968C76.1195 4.94968 77.4133 2.83854 82.4236 1.49676C85.7996 0.591908 88.99 0.83159 88.99 0.83159C88.99 0.83159 85.1569 -0.0968273 81.9701 0.889373C77.2634 2.35116 76.1195 4.94968 76.1195 4.94968Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 14.1852,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes3);
export default __webpack_public_path__ + "static/media/eyes-3.4ab978f070f47f477381b709cece59d4.svg";
export { ForwardRef as ReactComponent };